import Youtube, { YoutubeOptions } from '@tiptap/extension-youtube';

import { YOUTUBE_IFRAME_ALLOW } from './constants';

export type RteYoutubeOptions = YoutubeOptions & {
	/** Opens the URL prompt. Supplied by the editor, because the dialog is React state. */
	onRequestUrl?: () => void;
};

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		rteYoutube: {
			openYoutubePrompt: () => ReturnType;
		};
	}
}

export const RteYoutube = Youtube.extend<RteYoutubeOptions>({
	addOptions() {
		return {
			...this.parent?.(),
			onRequestUrl: undefined,
			HTMLAttributes: { allow: YOUTUBE_IFRAME_ALLOW },
		};
	},

	addCommands() {
		return {
			...this.parent?.(),
			openYoutubePrompt: () => () => {
				this.options.onRequestUrl?.();
				return true;
			},
		};
	},
});
